import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ModalDireccionEnvioClasesComponent } from '../modal-direccion-envio-clases/modal-direccion-envio-clases.component';
import { ModalDireccionEnvioUbigeoComponent } from '../modal-direccion-envio-ubigeo/modal-direccion-envio-ubigeo.component';
import { setConfigTable, basicAlert, timerOut, alertaConfirmacion } from 'src/app/shared/utils';
import { ClienteService } from 'src/app/services/cliente.service'
import { NgbModal, NgbActiveModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { Component, OnInit, OnChanges, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { MdIcUbigeoEdtComponent } from '../md-ic-ubigeo-edt/md-ic-ubigeo-edt.component';

@Component({
  selector: 'app-modal-direccion-envio',
  templateUrl: './modal-direccion-envio.component.html',
  styleUrls: ['./modal-direccion-envio.component.css']
})
export class ModalDireccionEnvioComponent implements OnInit, OnChanges {
  modalReference: any;
  public checkActivo: boolean = false;
  public DireccionTemp: any = {
    clases: []
  };
  public codcli: string = '';
  public editar: boolean = false;
  public btnUbigueoDisable: boolean = false;
  closeResult = '';
  dtTrigger: Subject<null> = new Subject();

  //Variables Modificar Clase
  editinputcla: any;
  editinputdescla: any;
  editinputcodigo: any;
  editinputdescodigo: any;
  editclase: any;
  editcond: any;
  editcontacto: any;
  editbanco: any;
  editespecificacion: any;
  listaclases = [];
  listacodigos = [];
  public codCodigoClase: number;
  public desCodigoClase: string;
  disabledCodigosClaseCombo: boolean = true;

  constructor(
    private modalactiveService: NgbActiveModal,
    private spinnerService: SpinnerService,
    private interlocutorService: InterlocutorService,
    private modalService: NgbModal,
    private clienteService: ClienteService,

  ) { }

  ngOnInit(): void {

    this.obtenerListaClases()
    this.checkActivo = true;
    if (this.editar)
      this.checkActivo = (this.DireccionTemp.swacti == "S" ? true : false);

    if (this.DireccionTemp != null && this.DireccionTemp.ubigeo != null) {
      this.btnUbigueoDisable = true;
    } else {
      this.btnUbigueoDisable = false;
    }

  }

  obtenerListaClases() {
    this.clienteService.buscarClases().subscribe(response => {
      this.listaclases = response.body;
    })
  }

  obtenerListaClasesCodigos(clase: any) {
    this.spinnerService.activarLoading(true)
    this.clienteService.buscarCodigos(clase).subscribe(response => {
      this.spinnerService.activarLoading(false)
      this.listacodigos = response.body;
    })
  }


  ngOnChanges() {
    // verifica si ya tiene ubigeo y habilita el boton

  }

  _close() {
    this.modalactiveService.dismiss('canceling');
  }

  onChangeActivo(isChecked: boolean) {
    this.checkActivo = isChecked;
  }

  nuevaDireccionEnvio() {
   
    if (this.DireccionTemp.descri == undefined || this.DireccionTemp.descri == null || this.DireccionTemp.descri == '') {
      basicAlert("El campo 'Descripción' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.DireccionTemp.direc1 == undefined || this.DireccionTemp.direc1 == null || this.DireccionTemp.direc1 == '') {
      basicAlert("El campo 'Dirección' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    this.DireccionTemp.direc1= (this.DireccionTemp.direc1 != undefined && this.DireccionTemp.direc1 != null && this.DireccionTemp.direc1.length > 0) ?this.DireccionTemp.direc1.trim():"";
    this.DireccionTemp.codcli = this.codcli;
    if (this.checkActivo != null && this.checkActivo) {
      this.DireccionTemp.swacti = "S"
    } else {
      this.DireccionTemp.swacti = "S"
    }

    // LLAMAR A SERVICIO DE INSERTAR DIRECCIONES
    this.spinnerService.activarLoading(true);
    this.interlocutorService.insertDireccionesEnvioInterlocutor(this.codcli, this.DireccionTemp).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      console.log(response);
      this.modalactiveService.close(response.body);
    }, err => {
      this.spinnerService.activarLoading(false);;
      if (err.status >= 500) {
        console.log(err);
        basicAlert('Servicio no disponible', 'warning', 'Aceptar', null, null,);
      } else {
        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
      }
    })


  }


  _actualizar() {


    if (this.DireccionTemp.descri == undefined || this.DireccionTemp.descri == null || this.DireccionTemp.descri == '') {
      basicAlert("El campo 'Descripción' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    if (this.DireccionTemp.direc1 == undefined || this.DireccionTemp.direc1 == null || this.DireccionTemp.direc1 == '') {
      basicAlert("El campo 'Dirección' es obligatorio.", 'warning', 'Aceptar');
      return;
    }
    this.DireccionTemp.direc1=(this.DireccionTemp.direc1 != undefined && this.DireccionTemp.direc1 != null && this.DireccionTemp.direc1.length > 0) ?this.DireccionTemp.direc1.trim():"";
    this.DireccionTemp.codcli = this.codcli;
    if (this.checkActivo != null && this.checkActivo) {
      this.DireccionTemp.swacti = "S"
    } else {
      this.DireccionTemp.swacti = "N"
    }

    this.spinnerService.activarLoading(true);
    this.interlocutorService.direccion_envio_actualizar(this.codcli, this.DireccionTemp.codenv, this.DireccionTemp).subscribe((response: any) => {
      this.spinnerService.activarLoading(false);
      this.modalactiveService.close(this.DireccionTemp);
      console.log(response);
    }, err => {
      this.spinnerService.activarLoading(false);;
      if (err.status >= 500) {
        basicAlert('Servicio no disponible', 'warning', 'Aceptar', null, null,);
      } else {
        basicAlert(err.error, 'warning', 'Aceptar', null, null,);
      }
    })


  }


  nuevoClase() {
    const referenciaModal = this.modalService.open(ModalDireccionEnvioClasesComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.result.then((data) => {
      console.log("view info success ")
      console.log(data);
      if (this.DireccionTemp.clases == null || this.DireccionTemp.clases == null)
        this.DireccionTemp.clases = [];
      if (data != null && data.clase != undefined && data.clase != null && data.clase > 0 && data.codigo != null && data.codigo != "") {
        this.DireccionTemp.clases.push(data);
      }
    }, (reason) => {
      console.log(reason);
    });
  }

  modificarUbigeo() {
    const referenciaModal = this.modalService.open(ModalDireccionEnvioUbigeoComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.result.then((data) => {
      console.log("view info success ")
      console.log(data);
      if (this.DireccionTemp.clases == null || this.DireccionTemp.clases == null)
        this.DireccionTemp.clases = [];
      if (data != null) {
        data.forEach(element => {
          this.DireccionTemp.clases.push(element);
        });
      }
    }, (reason) => {
      console.log(reason);
    });
  }

  EliminarClase(data: any) {
    alertaConfirmacion('¿Está seguro de eliminar el registro?', 'warning', false, true)
      .then((responseAlert) => {

        if (responseAlert != undefined && responseAlert != null && responseAlert) {


          this.spinnerService.activarLoading(true);
          /*
          this.DireccionTemp.clases = this.DireccionTemp.clases.filter(x => x.clase !== data.clase);
          
          this.dtTrigger.next();
          this.spinnerService.activarLoading(false);
          */

          this.clienteService.eliminar_clase_direcciones_envio(this.codcli, this.DireccionTemp.codenv, data.clase).subscribe((response: any) => {
            this.spinnerService.activarLoading(false);
            basicAlert('Se eliminó correctamente.', 'success', 'Aceptar', null, null);
            this.DireccionTemp.clases = [];
            this.interlocutorService.direccion_envio_obtener(this.codcli, null).subscribe((response: any) => {
              this.DireccionTemp.clases = response.body.clases;
              if (this.DireccionTemp.clases.find(x => x.clase == 14) == null) {
                console.log("CLASE CLASES 132")
                this.btnUbigueoDisable = false;
              }
              else {
                this.btnUbigueoDisable = true;
              }
            }, err => {
              this.spinnerService.activarLoading(false);
              console.log(err);
            });
          }, err => {
            this.spinnerService.activarLoading(false);
            console.log(err.error.mensaje);
            basicAlert(err.error, 'success', 'Aceptar');
          });

          this.DireccionTemp.clases = [...this.DireccionTemp.clases]
          this.closeResult;
        }

      })
  }

  open2(content2: string, cla: any) {
    if (cla.clase == 14 || cla.clase == 15 || cla.clase == 16) {
      this.editUbigeoDireccionesEnvio();
    } 
    else{
      this.spinnerService.activarLoading(true)
      console.log("nota")
      console.log(this.listaclases)
      console.log(cla)
      this.disabledCodigosClaseCombo = false;
      this.listacodigos = [];
      this.codCodigoClase = null;
  
      this.editinputcla = cla.clase;
      this.editinputdescla = cla.desclase;
      this.obtenerListaClasesCodigos(cla.clase);
      this.editinputcodigo = cla.codigo;
      this.editinputdescodigo = cla.descodigo;
      this.editclase = cla;
  
      this.modalReference = this.modalService.open(content2);
      this.spinnerService.activarLoading(true)
      this.modalReference.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
   
    /*
    this.modalService.open(content2, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    return;
    */
  }

  editUbigeoDireccionesEnvio() {

    let codDepart: string = '00';

    this.DireccionTemp.clases.forEach(element => {
      if (element.clase == 14) {
        codDepart = element.codigo;
      }
    });

    let codProv: string = null;
    this.DireccionTemp.clases.forEach(element => {
      if (element.clase == 15) {
        codProv = element.codigo;
      }
    });

    let codDist: string = null;
    this.DireccionTemp.clases.forEach(element => {
      if (element.clase == 16) {
        codDist = element.codigo;
      }
    });
    const referenciaModal = this.modalService.open(MdIcUbigeoEdtComponent, { backdrop: 'static', size: 'lg' });
    referenciaModal.componentInstance.editar = true;
    referenciaModal.componentInstance.codDepart = codDepart;
    referenciaModal.componentInstance.codProv = codProv;
    referenciaModal.componentInstance.codDist = codDist;
    referenciaModal.result.then((data) => {
      if (this.DireccionTemp.clases == null)
        this.DireccionTemp.clases = [];

      if (data != null) {

        this.DireccionTemp.clases.forEach(element => {
          if (element.clase == 14) {

            let departamento = data.find(item => item.clase == 14);;
            element.codigo = departamento.codigo;
            element.descodigo = departamento.descodigo;

          } else if (element.clase == 15) {

            let provincia = data.find(item => item.clase == 15);;

            element.codigo = provincia.codigo;
            element.descodigo = provincia.descodigo;


          } else if (element.clase == 16) {

            let distrito = data.find(item => item.clase == 16);
            element.codigo = distrito.codigo;
            element.descodigo = distrito.descodigo;


          }
        });

      }

      console.log(this.DireccionTemp.clases);

      if (this.DireccionTemp.clases.find(x => x.clase == 14) == null) {
        this.btnUbigueoDisable = false;
      } else {
        this.btnUbigueoDisable = true;
      }

    }, (reason) => {
      console.log(reason);
    });
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === 1) {
      return 'by pressing ESC';
    } else if (reason === 0) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  //Actualizar Clase
  guardarActualizarClase() {

    let arreglo = this.DireccionTemp.clases;
    let indice = arreglo.indexOf(this.editclase)



    arreglo[indice].clase = this.editinputcla;
    //
    this.listaclases.forEach(element => {
      if (element.codigo == this.editinputcla) {
        this.editinputdescla = element.descri;
      }
    });
    //  
    arreglo[indice].desclase = this.editinputdescla;

    arreglo[indice].codigo = this.editinputcodigo;
    //
    this.listacodigos.forEach(element => {
      if (element.codigo == this.editinputcodigo) {
        console.log(element)
        this.editinputdescodigo = element.descri;
      }
    });
    //
    arreglo[indice].descodigo = this.editinputdescodigo;


    this.DireccionTemp.clases = arreglo

    basicAlert('Se actualizó con éxito.', 'success', 'Aceptar', null, null);
    this.modalReference.close();
    return;
  }
  closeInsert() {
    this.borrarDatosInset();
  }
  borrarDatosInset() {
    //this.disabledBotonClases = true;
    this.disabledCodigosClaseCombo = true;
    this.codCodigoClase = null;
    this.desCodigoClase = '';
  }
}
